import { Expose } from "class-transformer";

export class ProductPriceData {
  @Expose()
  type!: string;

  @Expose()
  price!: number;

  @Expose()
  currencyCode!: string;

  constructor(type: string, price: number, currencyCode: string) {
    this.type = type;
    this.price = price;
    this.currencyCode = currencyCode;
  }
}
